import { useEffect } from 'react';
import { useAppSelector } from 'app/hooks';
import {
  selectBrandName,
  selectBrandFaviconUrl,
} from 'services/brand/brandSelectors';

function useDocumentTitle() {
  const brandName = useAppSelector(selectBrandName);
  const favicon = useAppSelector(selectBrandFaviconUrl);

  /* set brand name as document title */
  useEffect(() => {
    if (brandName) {
      document.title = brandName;
    }
  }, [brandName]);

  /* set brand favicon url as project favicon url */
  useEffect(() => {
    if (favicon) {
      let link = document.querySelector('link[rel~="icon"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = favicon;
    }
  }, [favicon]);
}

export default useDocumentTitle;
